package navigation


sealed class Screen {
    data object Cliente : Screen()
    data object Admin : Screen()
    data object Payment : Screen()

    data object SpeiConfirmation : Screen()
    data object OxxoConfirmation : Screen()

    data object Chofer : Screen()
    data object Tracking : Screen()
}